import numbro from 'numbro'
import numbroLangs from 'numbro/dist/languages.min'

import { getCountryIsoCode, getNewLangs, getCachedLocations } from './locations'
import { getLanguageCode } from './translation'

Object.values(getNewLangs()).forEach((country) => {
  const fromNumbro =
    numbroLangs[country.languageTag] ||
    numbroLangs[country.languageTag.substr(0, 2)] ||
    {}
  const merged = {
    ...country,
    ...fromNumbro,
    languageTag: country.languageTag,
    delimiters: country.delimiters,
    currency: {
      ...country.currency,
      position: country.currency.position,
    },
  }
  numbro.registerLanguage(merged)
})

const DEFAULT_LOCALES = {
  en: 'en-US',
  pt: 'pt-PT',
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  nl: 'nl-NL',
  it: 'it-IT',
  ja: 'ja-JP',
  zh: 'zh-CN',
}

const getCurrentLocale = () => {
  const language = getLanguageCode()
  return DEFAULT_LOCALES[language]
}

export const formatLocale = ({ lang, locId }) => {
  return `${lang.substr(0, 2)}-${getCountryIsoCode(
    locId,
    getCachedLocations(),
  )}`
}

export const localizeNumbro = (loc = null) => {
  const locale =
    loc && loc.lang
      ? formatLocale({
          lang: loc.lang,
          locId: loc.locId,
        })
      : getCurrentLocale()
  numbro.setLanguage(locale)
}

export const formatNumber = (
  x,
  withCurrency = false,
  decimalCounts = 2,
  forcedRegion = { locId: 0, lang: 'xxx' },
  useAbbreviation = true,
  abbrUnit = 1000000,
) => {
  if (typeof x === 'string' && isNaN(x)) {
    return x
  }

  if (forcedRegion?.locId !== 0) {
    localizeNumbro(forcedRegion)
  }

  if (typeof x === 'undefined' || x === null || isNaN(x)) {
    return '_'
  }
  if (x === '00' || x === '000' || x === '0000') return x

  const value = x === '' ? 0 : x
  const format = {
    thousandSeparated: true,
    mantissa: (() => {
      if (withCurrency) {
        return decimalCounts
      }

      return useAbbreviation && value >= abbrUnit ? 1 : 0
    })(),
    average: useAbbreviation && value >= abbrUnit,
  }

  if (withCurrency) {
    const { lang, locId } = forcedRegion || {}
    const isUSFormat =
      (lang === 'en' && locId === 2840) || forcedRegion.locId === 0
    const usFormat = isUSFormat ? 'US' : ''
    return `${usFormat}${numbro(value)?.formatCurrency(format) || ''}`
  }

  return numbro(value).format(format)
}

export const formatDecimal = (x, decimalCounts = 2) => {
  if (typeof x === 'undefined') {
    return '_'
  }

  const value = isNaN(x) || x === '' ? 0 : x
  return parseFloat(value).toFixed(decimalCounts)
}

export const formatThousandSeparated = (n) => {
  localizeNumbro()
  return numbro(n).format({
    thousandSeparated: true,
    mantissa: 0,
  })
}

export const unformatNumber = (number) => {
  return numbro.unformat(number.replace('US', ''))
}
